import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-yellow-500 text-black text-center py-2 font-semibold text-sm fixed bottom-0 left-0 w-full z-50 shadow-[0_-2px_8px_rgba(0,0,0,0.15)] flex items-center justify-center gap-3"
}
const _hoisted_2 = { class: "inline-flex items-center gap-1" }
const _hoisted_3 = {
  key: 0,
  class: "opacity-75"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.userStore.isImpersonated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _cache[1] || (_cache[1] = _createTextVNode(" ⚠️ Impersonating ", -1)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.userStore.email), 1),
          (_ctx.userStore.impersonatedBy)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (by " + _toDisplayString(_ctx.userStore.impersonatedBy) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.countdown !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["bg-black/10 rounded px-2 py-0.5 tabular-nums", { 'text-red-800 font-bold animate-pulse': _ctx.isExpiringSoon }])
            }, _toDisplayString(_ctx.formattedCountdown), 3))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "bg-black/20 hover:bg-black/30 rounded px-3 py-0.5 transition-colors",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.endImpersonation && _ctx.endImpersonation(...args)))
        }, " End Session ")
      ]))
    : _createCommentVNode("", true)
}